import {
  Component,
  inject,
  HostListener,
  Renderer2,
  OnDestroy,
  effect,
  Inject
} from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import {
  LucideAngularModule,
  X,
  HelpCircle,
  Lightbulb,
  Info,
  CheckCircle2,
  BookOpen,
  Sparkles
} from 'lucide-angular';
import { HelpModalService } from '../../services/help-modal.service';

@Component({
  selector: 'app-contextual-help-modal',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './contextual-help-modal.component.html',
  styleUrl: './contextual-help-modal.component.scss'
})
export class ContextualHelpModalComponent implements OnDestroy {
  readonly X = X;
  readonly HelpCircle = HelpCircle;
  readonly Lightbulb = Lightbulb;
  readonly Info = Info;
  readonly CheckCircle2 = CheckCircle2;
  readonly BookOpen = BookOpen;
  readonly Sparkles = Sparkles;

  public readonly helpService = inject(HelpModalService);
  private readonly renderer = inject(Renderer2);

  constructor(@Inject(DOCUMENT) private readonly document: Document) {
    // Sincroniza a classe 'body-modal-open' no body para travar scroll de fundo no mobile
    effect(() => {
      if (this.helpService.isOpen()) {
        this.renderer.addClass(this.document.body, 'body-modal-open');
      } else {
        this.renderer.removeClass(this.document.body, 'body-modal-open');
      }
    });
  }

  @HostListener('window:keydown.escape', ['$event'])
  onKeydownEscape(event: KeyboardEvent): void {
    if (this.helpService.isOpen()) {
      event.preventDefault();
      this.close();
    }
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }

  close(): void {
    this.helpService.close();
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.body, 'body-modal-open');
  }
}
